import {IndexPath, Layout, Select, SelectItem} from '@ui-kitten/components';
import React, {useEffect, useMemo, useState} from 'react';
import {StyleSheet} from 'react-native';
import {px, useAsyncFn} from '../../utils';
import {postRegisterKidsProfile} from '../../apis';
import {LoadingButton, Page} from '../components';
import StudentForm from './StudentForm';
import {useNavigation, useRoute} from '@react-navigation/native';
import {useSelector} from 'react-redux';

const StudentRegistration = () => {
  const navigation = useNavigation();
  const {params} = useRoute();
  const grades = useSelector((state) => state.general.grades);

  const initialStudentData = useMemo(
    () => ({
      studentName: '',
      gender: 'Male',
      gradeId: grades[0]?.id,
      dob: new Date(new Date().setFullYear(new Date().getFullYear() - 20)),
    }),
    [grades],
  );

  const [numOfStudentsIndex, setNumOfStudentsIndex] = useState(
    new IndexPath(0),
  );
  const [studentsData, setStudentsData] = useState([initialStudentData]);

  const numOfStudents = numOfStudentsIndex.row + 1;

  useEffect(() => {
    const numOfAddingToList = numOfStudents - studentsData.length;
    if (numOfAddingToList > 0) {
      const addingData = [];
      for (let index = 0; index < numOfAddingToList; index++) {
        addingData.push(initialStudentData);
      }
      setStudentsData([...studentsData, ...addingData]);
    } else if (numOfAddingToList < 0) {
      const remainingData = [];
      for (let index = 0; index < numOfStudents; index++) {
        remainingData.push(studentsData[index]);
      }
      setStudentsData(remainingData);
    }
  }, [initialStudentData, numOfStudents, studentsData]);

  const [{loading}, handleRegisterKids] = useAsyncFn(async () => {
    await postRegisterKidsProfile(studentsData);
    params.onRegisterSuccess();
    navigation.goBack();
  }, [studentsData]);

  const setStudentData = (indexToUpdate, newData) => {
    setStudentsData((students) =>
      students.map((oldData, oldIndex) =>
        oldIndex === indexToUpdate ? newData : oldData,
      ),
    );
  };

  return (
    <Page header={{title: 'Student registration', showBackAction: true}}>
      <Layout style={styles.body}>
        <Select
          label="How many students are you registering?"
          value={numOfStudents}
          selectedIndex={numOfStudentsIndex}
          onSelect={setNumOfStudentsIndex}>
          {[1, 2, 3, 4].map((num) => (
            <SelectItem title={String(num)} key={num} />
          ))}
        </Select>
        {studentsData.map((data, index) => (
          <StudentForm
            data={data}
            setData={(newData) => setStudentData(index, newData)}
            index={index + 1}
            key={index}
          />
        ))}
        <LoadingButton
          loading={loading}
          style={styles.marginTop}
          onPress={() => handleRegisterKids()}>
          {'Submit'}
        </LoadingButton>
      </Layout>
    </Page>
  );
};

const styles = StyleSheet.create({
  body: {
    padding: px(17),
  },
  marginTop: {
    marginTop: px(40),
  },
});

export default StudentRegistration;
